import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class GroupPermissionModel extends BaseModel {

    constructor() {
        super({ 
                name: "group_permission",
                tableName: 'group_permission', 
                label: "Phân quyền", 
                display_key: 'name', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            name: {
                name: 'name', 
                type: "String",
                label: 'Nhóm quyền',
                class: 'center',
                filter: { type: 'input', match: 'contains'},
                // display: false
            }
        },)
    }

}